import React from 'react'

const OurMission = () => {
  return (
    <>
     <div className="mission-section padding-container">
        <div className="page-wrapper">
            <div className="mission-full-box">
            <div className="mission">
                <div className="mission-text">
                    <h1>
                        OUR <span className='orange-text'>MISSION</span>
                    </h1>
                    <p>
                        At VisionBird Technologies, our mission is to empower our clients to become more agile,
                        innovative,
                        and profitable. We strive to deliver cutting-edge IT solutions and forward-thinking software
                        technologies that keep you ahead of the competition — not just by
                        one step, but by several. </p>
                </div>


            </div>
            <div className="Grid-3-box  our_mission_box">
                <div className="mission-box">
                    <div className="mission-icon">
                        <img src="/assets/Images/3d_box.png" alt="" width="30px" height="30px"/>
                    </div>
                    <div className="mission-box-text">
                        <h1>
                            EMPOWER BUSINESS AGITITY
                        </h1>
                        <p>
                            Deliver adaptable digital solutions that help
                            businesses respond quickly to changing markets. </p>
                    </div>

                </div>


                <div className="mission-box">
                    <div className="mission-icon">
                        <img src="/assets/Images/3d_box.png" alt="" width="30px" height="30px"/>
                    </div>
                    <div className="mission-box-text">
                        <h1>
                            DRIVE TECHNOLOGICAL EXCELLENCE
                        </h1>
                        <p>
                            Provide top-tier software development and IT
                            services using the latest tools and frameworks. </p>
                    </div>

                </div>



                <div className="mission-box">
                    <div className="mission-icon">
                        <img src="/assets/Images/3d_box.png" alt="" width="30px" height="30px"/>
                    </div>
                    <div className="mission-box-text">
                        <h1>
                            FUEL CLIENT SUCCESS
                        </h1>
                        <p>
                            Build long-term partnerships by focusing on
                            measurable results and client satisfaction. </p>
                    </div>

                </div>


            </div>
            </div>
        </div>

    </div>


    </>
  )
}

export default OurMission
